/* eslint-disable no-dupe-keys */
export default {
  advertising_space: {
    name: '广告位',
    // 属性（一般与对象内容匹配）
    prop: {
      name: '广告位',
      code: '广告位编号',
      allow_media_types: '支持媒体类型',
      max_size: '媒体大小',
      image_max_size: '图片媒体大小',
      video_max_size: '视频媒体大小',
      media_dimensions: '媒体尺寸',
      multiple: '支持多个媒体',
      advertising_type: '广告分类'
    },
    // Enum的属性
    advertising_type: {
      normal_advertising: '常规广告',
      station_advertising: '场站广告'
    },
    multiple: {
      true: '支持',
      false: '不支持'
    },
    // Boolean的属性
    // 详情页标签
    // 标签标题
    // 标题
    // 广告
    // 展示范围
    // 媒体类型
    media_type: {
      image: '图片',
      video: '视频'
    },
    // 状态
    // 排序
    sorting: {
      cancel_sorting: '取消排序',
      save_sorting: '保存排序',
      advertisement_sorting: '广告排序'
    }
  }
}
